import * as types from '../constants/actionTypes'

export const receiveShopifyAssets = (shopName, assets, texts, collections, videos) => (
  {
    type: types.RECEIVE_SHOPIFY_ASSETS,
    shopName,
    assets,
    texts,
    collections,
    videos
  }
)

export const receiveShopifyCollectionProducts = (collectionId, products) => (
  {
    type: types.RECEIVE_SHOPIFY_COLLECTION_PRODUCTS,
    collectionId,
    products
  }
)



// WEBPACK FOOTER //
// ./src/actions/shopifyAppDataAC.js